import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@material-ui/core';
import { Undo as UndoIcon } from '@material-ui/icons';
import ReactToPrint from 'react-to-print';
import ComponentToPrint from '../../utils/component_to_print';
import ModalPreview from '../../utils/modal_preview';

const useStyles = makeStyles(theme => ({
    button: {
        color: '##2596be',
        textTransform: 'none',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 3),
        transition: theme.transitions.create(['color', 'background-color'], {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.standard
        }),
        fontSize: theme.typography.fontSize,
        fontWeight: theme.typography.fontWeightRegular,
        '&:focus': {
            outline: 'none'
        }
    }
}));

export const DefaultButton = ({ label, icon: Icon, handleClick, onClick }) => {
    const { button } = useStyles();

    return (
        <Button
            color="primary"
            size="large"
            className={button}
            onClick={handleClick || onClick}
        >
            {Icon && <Icon />} {label}
        </Button>
    );
};

DefaultButton.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.any,
    handleClick: PropTypes.func,
    onClick: PropTypes.func
};

export const BackButton = (props) => {

    return (
        <DefaultButton
            {...props}
            label={'Nazad'}
            icon={UndoIcon}
        />
    );
};

export const ShowFiltersButton = (props) => {
    const { shown } = props;

    return (
        <DefaultButton
            {...props}
            label={shown ? 'Sakrij filtere' : 'Prikaži filtere'}
        />
    );
};

ShowFiltersButton.propTypes = {
    shown: PropTypes.bool
};

export const PrintButton = (props) => {
    const { getPrintContent } = props;

    const printRef = useRef(null);
    const [printContent, setPrintContent] = useState(null);

    const handleGetPrintContent = async () => {
        const response = await getPrintContent();
        setPrintContent(response);
    }

    return (
            <>
                <div style={{ display: 'none'}}><ComponentToPrint content={printContent} ref={printRef} /></div>
                <ReactToPrint
                    onBeforeGetContent={handleGetPrintContent}
                    trigger={() => (
                        <DefaultButton
                            label={props.label || "Štampa"}
                        />
                    )}
                    content={() => printRef.current}
                />
            </>
    )
}

PrintButton.propTypes = {
    getPrintContent: PropTypes.func,
    label: PropTypes.string
};

export const PreviewButton = (props) => {
    const { getPreviewContent } = props;
    const [previewContent, setPreviewContent] = useState(null);
    const previewRef = useRef(null);

    // Modal Preview
    const [openPreview, setOpenPreview] = useState(false);
    const handleClosePreview = () => {
        setOpenPreview(false);
    };

    const handleGetPreviewContent = async () => {
        const response = await getPreviewContent();
        setPreviewContent(response);
        setOpenPreview(true);
    }

    return (
            <>
                <DefaultButton
                    {...props}
                    label="Pregled"
                    handleClick={handleGetPreviewContent}
                />
                <ModalPreview
                    open={openPreview}
                    handleClose={handleClosePreview}
                    content={previewContent}
                    previewRef={previewRef}
                />
            </>
    )
}

PreviewButton.propTypes = {
    getPreviewContent: PropTypes.func
};
